exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/exercise-starter/exercise-starter.component.css
// module id = ../../../../../src/app/exercise-starter/exercise-starter.component.css
// module chunks = main